import * as actions from '../actions/easymsOrganizationsActions'
import { getParser } from '../adapters'
import { handleError, handleResponse, securedFetch } from './apiUtils'
import * as urls from './urls'

/** @thunk **/
export const fetchEasymsOrganizations = () => (dispatch, getState) => {
    dispatch(actions.easyms_fetchOrganizationsRequest())

    const { auth } = getState()

    securedFetch(urls.easymsOrganizations, auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.easyms_fetchOrganizationsSuccess(getParser(urls.easymsOrganizations)(json))))
        .catch(
            handleError(
                dispatch,
                actions.easyms_fetchOrganizationsFailure,
                'Что-то пошло не так!',
                'При получении организаций произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/easymsOrganizationsApi.js